import React, { useState } from 'react';
import './App.scss';
import './i18n';
import { useTranslation } from 'react-i18next';
import SearchCommandBuilder from './components/SearchCommandBuilder';


function App() {
  const [selectedSite] = useState('google');
  const { t } = useTranslation();


  return (
    <div className="App">
      <main>
      <SearchCommandBuilder selectedSite={selectedSite} />
      </main>
    </div>
  );
}

export default App;
